import React from 'react';

const CustomersIcon = ({ stroke }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2225_27040)">
      <path d="M19.1667 17.4999V15.8333C19.1661 15.0947 18.9203 14.3773 18.4678 13.7935C18.0153 13.2098 17.3818 12.7929 16.6667 12.6083" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16666C3.28261 12.5 2.43476 12.8512 1.80964 13.4763C1.18452 14.1014 0.833328 14.9493 0.833328 15.8333V17.5" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.3333 2.60828C14.0503 2.79186 14.6859 3.20886 15.1397 3.79353C15.5935 4.37821 15.8399 5.0973 15.8399 5.83744C15.8399 6.57758 15.5935 7.29668 15.1397 7.88135C14.6859 8.46603 14.0503 8.88303 13.3333 9.06661" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.50001 9.16667C9.34095 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34095 2.5 7.50001 2.5C5.65906 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65906 9.16667 7.50001 9.16667Z" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2225_27040">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

);

export default CustomersIcon;
